webpackJsonp([1],{

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Layout_FullscreenLayout_vue__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Layout_FullscreenLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Layout_FullscreenLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Artists_Directory__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Artists_Directory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Artists_Directory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Artists_ArtistProfile__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Artists_ArtistProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Artists_ArtistProfile__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_Layout_FullscreenLayout_vue___default.a,
    redirect: '/',
    children: [{
      path: '',
      name: 'ArtistsDirectory',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Artists_Directory___default.a
    }, {
      path: ':id',
      name: 'ArtistProfile',
      component: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_Artists_ArtistProfile___default.a
    }]
  }],
  // mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    console.log('scrollBehavior', savedPosition);
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    apiURL: 'https://api.vividartsapp.com',
    errors: 0,
    axiosConfig: {
      headers: {
        'enterprise-id': window.VividArts.eId,
        'edomain': window.VividArts.domain || window.location.hostname.split('.')[0]
      }
    },
    placeholderArtistImg: 'http://res.cloudinary.com/vividarts/image/upload/c_scale,w_600/v1518396723/directory/ccpbc-artist-placeholder.jpg',

    artworksRef: {},
    artistsRef: {},
    blogsRef: {},
    blogSourcesRef: {},
    usersRef: {},
    authorsRef: {},
    eventsRef: {},
    placesRef: {},
    regionsRef: {},
    enterprisesRef: {},

    artworks: [],
    artists: [],
    blogs: [],
    blogSources: [],
    users: [],
    authors: [],
    events: [],
    places: [],
    regions: [],
    enterprises: [],

    states: ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'],
    countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor L\'Este', 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
    statuses: ['active', 'pending', 'deleted'],
    types: ['Mural', 'Sculpture', 'Installation', 'Live Performance', 'Exhibition', 'Film Viewings', 'Art Walks', 'Social Event', 'Opening Reception', 'Artist Only'],
    artworkTour: {
      artworks: [],
      directions: {}
    }
  },
  mutations: {
    setArtworks: function setArtworks(state, payload) {
      console.log('Artworks ->', payload);
      state.artworks = payload.artworks;
      state.artworksRef = payload.artworksRef;
    },
    setArtists: function setArtists(state, payload) {
      console.log('Artists ->', payload);
      state.artists = payload.artists;
      state.artistsRef = payload.artistsRef;
    },
    setBlogs: function setBlogs(state, payload) {
      console.log('Blogs ->', payload);
      state.blogs = payload.blogs;
      state.blogsRef = payload.blogsRef;
    },
    setBlogSources: function setBlogSources(state, payload) {
      console.log('BlogSources ->', payload);
      state.blogSources = payload.blogSources;
      state.blogSourcesRef = payload.blogSourcesRef;
    },
    setUsers: function setUsers(state, payload) {
      console.log('Authors ->', payload);
      state.users = payload.users;
      state.usersRef = payload.usersRef;
    },
    setAuthors: function setAuthors(state, payload) {
      console.log('Authors ->', payload);
      state.authors = payload.authors;
      state.authorsRef = payload.authorsRef;
    },
    setEvents: function setEvents(state, payload) {
      console.log('Events ->', payload);
      state.events = payload.events;
      state.eventsRef = payload.eventsRef;
    },
    setPlaces: function setPlaces(state, payload) {
      console.log('Places ->', payload);
      state.places = payload.places;
      state.placesRef = payload.placesRef;
    },
    setRegions: function setRegions(state, payload) {
      console.log('Regions ->', payload);
      state.regions = payload.regions;
      state.regionsRef = payload.regionsRef;
    },
    setEnterprises: function setEnterprises(state, payload) {
      console.log('Enterprises ->', payload);
      state.enterprises = payload.enterprises;
      state.enterprisesRef = payload.enterprisesRef;
    },
    setArtworkTour: function setArtworkTour(state, payload) {
      console.log('Artwork Tour ->', payload);
      if (payload.artworks) {
        state.artworkTour.artworks = payload.artworks;
      }
      if (payload.directions) {
        state.artworkTour.directions = payload.directions;
      }
    }
  },
  actions: {
    buildArtworkTour: function buildArtworkTour(_ref, data) {
      var commit = _ref.commit,
          state = _ref.state;

      console.log('directions data', data);
      var url = 'http://vividartsapp.com/embeded/tours.php';

      var params = new URLSearchParams();
      params.append('u', data);

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, params).then(function (response) {
        // JSON responses are automatically parsed.
        console.log('buildArtworkTour', response.data);

        if (response.data.status === 'OK') {
          commit('setArtworkTour', { directions: response.data });
          //   this.loadingRoute = false
          //
          //   this.tourArtworkOrder = response.data.routes[0].waypoint_order
          //
          //   var orderedSelectedArtworks = []
          //   for (var i = 0; i < this.tourArtworkOrder.length; i++) {
          //     var idx = this.tourArtworkOrder[i]
          //     orderedSelectedArtworks.push(this.selectedArtworks[idx])
          //   }
          //   this.selectedArtworks = orderedSelectedArtworks
          //   this.tourMapPaths = this.decode(response.data.routes[0].overview_polyline.points)
          //     .map(function (item) {
          //       return {
          //         lat: item.latitude,
          //         lng: item.longitude
          //       }
          //     })
          //   this.directionsList = response.data.routes[0].legs[0].steps.map(function (item) {
          //     return {
          //       avatar: '',
          //       subtitle: item.html_instructions,
          //       title: item.travel_mode,
          //       polyline: item.polyline
          //     }
          //   })
        }
      }).catch(function (e) {
        console.log(e);
        // this.errors.push(e)
        // this.loadingRoute = true

        // this.loadingRoute = false
        // this.appStep = 1
      });
    }
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(617),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lazyload__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_moment__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




















__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_7_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyB9K3QE2QtxtCXIkiwy9vyecmllsZzn7mM',
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9_axios___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('thumbnailURL', function (value) {
  if (typeof value === 'undefined') {
    return '';
  }
  var s = value.replace('upload/', 'upload/c_scale,w_300/');
  return s;
});
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('resizedURL', function (value, width) {
  if (typeof value === 'undefined') {
    return '';
  }
  var s = value.replace('upload/', 'upload/c_scale,w_' + width + '/');
  return s;
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app-vivid-arts-pro',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(301);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'Vivid Arts Pro Artist'
    };
  },

  watch: {},
  computed: {}
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  computed: {}
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FullscreenContent_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FullscreenContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FullscreenContent_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import TopNavbar from './TopNavbar.vue'
// import ContentFooter from './ContentFooter.vue'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    // TopNavbar,
    // ContentFooter,
    FullscreenContent: __WEBPACK_IMPORTED_MODULE_0__FullscreenContent_vue___default.a
  },
  props: [],
  methods: {},
  computed: {}
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'artistProfile',
  components: {
    'gallery': __WEBPACK_IMPORTED_MODULE_2_vue_gallery___default.a
  },
  created: function created() {
    this.initTabs();
    this.fetchArtist();
    __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a.scrollTo('#artist-page', 0, this.scrollOptions);
  },
  data: function data() {
    return {
      msg: 'Welcome to Artist Profile',
      themeColor: this.$store.state.config && this.$store.state.config.themeColor || '#9E9E9E',
      enterpriseLogo: typeof window.VividArts !== 'undefined' && window.VividArts.enterpriseLogo || 'https://www.palmbeachculture.com/wp-content/uploads/cultural-council-palm-beach-county-logo-web@2x.png',
      enterpriseLogoContain: true,
      show: true,
      urid: parseInt(window.VividArts.urid),
      activeTab: 'tab-about',
      lightboxIndex: null,
      galleryLightboxIndex: null,
      scrollOptions: {
        el: '#artist-page',
        easing: 'ease-in',
        offset: -200,
        cancelable: true,
        onDone: function onDone() {
          // scrolling is done
        },
        onCancel: function onCancel() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      },
      hasTabs: [false, false, false, false],
      breadcrumbs: [],

      artistArtworkImages: [],
      artistArtworks: [],
      enterprise: {},
      artist: {},
      enableEditArtistLink: false,
      placeHolderArtistImg: this.$store.state.placeholderArtistImg,

      mapCenter: { lat: 26.71348, lng: -80.0580457 },
      artworkMarkers: [],
      bounds: null,
      infoContent: '',
      infoImage: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      tabs: [
        // {
        //   name: 'artworks',
        //   icon: 'brush'
        // },
        // {
        //   name: 'about',
        //   icon: 'info_outline'
        // }
        // {
        //   name: 'store',
        //   icon: 'store'
        // }
      ],
      items: [{ active: true, title: 'Followers' }, { active: true, title: 'Following' }, { title: 'Artworks' }],
      shareMenu: [{ title: 'Facebook' }, { title: 'Instagram' }, { title: 'Twitter' }, { title: 'Email' }]
    };
  },

  watch: {},
  computed: {
    // artist () {
    //   var key = this.$route.params.id
    //   var a = this.artists.filter(function (item) {
    //     return item['.key'] === key
    //   })
    //   if (a.length > 0) {
    //     return a[0]
    //   }
    //   return null
    // },
    shouldIncludeCVTab: function shouldIncludeCVTab() {
      console.log('shouldIncludeCVTab');
      var at = this.tabs.filter(function (item) {
        return item.name === 'cv';
      });

      if (typeof this.artist === 'undefined' || at.length > 0) {
        return false;
      }

      if (typeof this.artist.exhibitions !== 'undefined' && this.artist.exhibitions.length) {
        this.addCVTab();
        return true;
      }

      if (typeof this.artist.podcasts !== 'undefined' && this.artist.podcasts.length) {
        this.addCVTab();
        return true;
      }

      if (typeof this.artist.videos !== 'undefined' && this.artist.videos.length) {
        this.addCVTab();
        return true;
      }

      if (typeof this.artist.printBlogs !== 'undefined' && this.artist.printBlogs.length) {
        this.addCVTab();
        return true;
      }

      return false;
    }
    // enterprise () {
    //   var eid = window.VividArts.enterpriseId
    //   if (typeof eid !== 'undefined') {
    //     var e = this.enterprises.filter(function (item) {
    //       return item['.key'] === eid
    //     })
    //     if (e.length > 0) {
    //       return e[0]
    //     } else {
    //       return null
    //     }
    //   }
    //   return null
    // },
    // artistArtworks () {
    //   var key = this.$route.params.id
    //   var a = this.artworks.filter(function (item) {
    //     if (typeof item.artists !== 'undefined') {
    //       return item.status === 'active' && item.artists.indexOf(key) >= 0 && item.cloudinaryImageURL
    //     }
    //     return false
    //   })
    //   // if (a.length > 0) {
    //   //   var vm = this
    //   //   setTimeout(function () {
    //   //     vm.initMap()
    //   //   }, 1)
    //   // }
    //   return a
    // },
    // artistArtworkImages () {
    //   return this.artistArtworks.map(function (item) {
    //     return item.cloudinaryImageURL
    //   })
    // }

  },
  methods: {
    initMap: function initMap() {
      console.log('init map');
      this.bounds = new window.google.maps.LatLngBounds();
      var bounds = this.bounds;
      this.artworkMarkers = this.artistArtworks.filter(function (item) {
        return typeof item.latitude !== 'undefined' && item.latitude !== '' && typeof item.longitude !== 'undefined' && item.longitude !== '';
      }).map(function (item) {
        bounds.extend({ lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) });
        return {
          position: { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) },
          icon: 'http://res.cloudinary.com/vividarts/image/upload/c_scale,w_30/v1506999888/poi-marker_hw5lin.png',
          infoText: item.name,
          infoImage: item.cloudinaryImageURL
        };
      });
      var fam = this.fitArtworkMarkers;
      setTimeout(function () {
        fam();
      }, 500);
    },
    fitArtworkMarkers: function fitArtworkMarkers() {
      console.log('fitArtworkMarkers', this.$refs, this.bounds);
      if (typeof this.$refs.artworksMap !== 'undefined' && this.$refs.artworksMap.length) {
        this.$refs.artworksMap[0].$mapObject.fitBounds(this.bounds);
      }
    },
    fetchArtistRevisions: function fetchArtistRevisions() {
      var _this = this;

      console.log('fetch artists');
      var requestURL = this.$store.state.apiURL + '/enterprises/' + window.VividArts.eId + '/revisions/artist/' + this.$route.params.id;
      // /enterprises/:enterpriseId/revisions/artist/:artistId

      this.axios.get(requestURL, this.$store.state.axiosConfig).then(function (response) {
        var data = response.data;
        console.log('API | artists revisons', data);
        if (data === null) {
          return;
        }
        var artistRevisions = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]._.clone(data, false);
        // debugger
        var revisonKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(artistRevisions).map(function (item) {
          return parseInt(item);
        });

        var maxOfArray = Math.max.apply(Math, revisonKeys);
        var latestRevision = artistRevisions[maxOfArray];
        _this.artist = latestRevision;

        if (typeof _this.artist.bio !== 'undefined') {
          _this.artist.bio = unescape(_this.artist.bio);
        }
        if (typeof _this.artist.excerpt !== 'undefined') {
          _this.artist.excerpt = unescape(_this.artist.excerpt);
        }
        _this.initTabs();

        // debugger
      });
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      this.infoImage = marker.infoImage;

      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    facebookURL: function facebookURL() {
      return 'https://www.facebook.com/' + this.artist.contactFacebook.replace('@', '');
    },
    instagramURL: function instagramURL() {
      return 'https://www.instagram.com/' + this.artist.contactInstagram.replace('@', '');
    },
    pinterestURL: function pinterestURL() {
      return 'https://www.pinterest.com/' + this.artist.contactPinterest;
    },
    twitterURL: function twitterURL() {
      return 'https://www.twitter.com/' + this.artist.contactTwitter;
    },
    websiteURL: function websiteURL() {
      var url = '';
      if (this.artist.contactWebsite.indexOf('http://') === -1 && this.artist.contactWebsite.indexOf('https://') === -1) {
        url += 'http://';
      }
      url += this.artist.contactWebsite;
      return url;
    },
    setBreadCrumbs: function setBreadCrumbs() {
      this.breadcrumbs = [];
      this.breadcrumbs.push({
        text: 'All Artists',
        disabled: false,
        href: { name: 'ArtistsDirectory' }
      });
      this.breadcrumbs.push({
        text: this.artist.fullName,
        disabled: false
      });
    },
    fetchArtist: function fetchArtist() {
      var _this2 = this;

      console.log('fetch artists');
      // debugger
      if (typeof this.$route.query !== 'undefined' && typeof this.$route.query.preview !== 'undefined' && this.$route.query.preview === 1) {
        this.fetchArtistRevisions();
        return;
      }
      var requestUrl = this.$store.state.apiURL + '/artists/' + this.$route.params.id;
      var vm = this;
      this.axios.get(requestUrl, this.$store.state.axiosConfig).then(function (response) {
        var data = response.data;
        // console.log('API | artists', data)
        if (data === null) {
          return;
        }

        vm.artist = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]._.clone(data, false);
        if (typeof vm.artist.bio !== 'undefined') {
          vm.artist.bio = unescape(vm.artist.bio);
        }
        if (typeof vm.artist.excerpt !== 'undefined') {
          vm.artist.excerpt = unescape(vm.artist.excerpt);
        }
        vm.initTabs();
        __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a.scrollTo('#artist-page', 0, _this2.scrollOptions);
        console.log('VueScrollTo');
      });
    },
    initTabs: function initTabs() {
      // console.log(this.artist.gallery)
      this.setBreadCrumbs();
      if (typeof this.artistArtworks !== 'undefined' && this.artistArtworks.length) {
        var hasItem1 = this.tabs.filter(function (item) {
          return item.name === 'artworks';
        });
        if (hasItem1.length === 0) {
          this.tabs.push({
            name: 'artworks',
            icon: 'brush'
          });
        }
      }

      // if (typeof this.artist.bio !== 'undefined' && this.artist.bio !== '') {
      var hasItem2 = this.tabs.filter(function (item) {
        return item.name === 'about';
      });
      if (hasItem2.length === 0) {
        this.tabs.push({
          name: 'about',
          icon: 'info_outline'
        });
        this.hasTabs[0] = true;
      }
      // }

      if (typeof this.artist.gallery !== 'undefined' && this.artist.gallery.length) {
        var hasItem3 = this.tabs.filter(function (item) {
          return item.name === 'gallery';
        });
        if (hasItem3.length === 0) {
          this.tabs.push({
            name: 'gallery',
            icon: 'photo_library'
          });
          this.hasTabs[2] = true;
        }
      }

      if (this.tabs.length > 0) {
        this.activeTab = 'tab-' + this.tabs[0].name;
        console.log('activeTab -->', this.activeTab);
      }

      if ([1, 2, 3].indexOf(parseInt(window.VividArts.urid)) >= 0 && typeof window.VividArts.connections !== 'undefined' && typeof window.VividArts.connections.enterpriseArtists !== 'undefined' && typeof window.VividArts.uid !== 'undefined' && window.VividArts.connections.enterpriseArtists === this.$route.params.id) {
        this.enableEditArtistLink = true;
      }
    },
    addCVTab: function addCVTab() {
      this.tabs.push({
        name: 'cv',
        icon: 'info_outline'
      });
      this.hasTabs[3] = true;
    }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_PulseLoader_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Directory',
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiperSlide"],
    PulseLoader: __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_PulseLoader_vue___default.a
  },
  created: function created() {
    this.fetchArtists();
    this.fetchEnterpriseDirectory();
  },
  data: function data() {
    return {
      enterpriseLogo: window.VividArts.enterpriseLogo,
      enterpriseLogoContain: true,
      artistSearch: null,

      pageLoder: true,
      color: '#136FAB',
      size: '30px',

      scrollOptions: {
        el: '#artist-grid-wrap',
        easing: 'ease-in',
        offset: -200,
        cancelable: true,
        onDone: function onDone() {
          // scrolling is done
        },
        onCancel: function onCancel() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      },
      page: 1,
      maxArtistCount: 6,
      numberOfPages: 0,
      dd1: null,
      dd2: null,
      dd3: null,
      artistTypes: window.VividArts.types || [],
      cities: [],
      enterprise: {},
      fRegions: [],

      activeCategories: [],
      directories: {},
      directory: {},
      directoryType: 'artists',
      errorMsg: 'No results found.',

      swiperOption: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        paginationClickable: true,
        spaceBetween: 30,
        loop: true,
        autoplay: 2500,
        effect: 'fade'
      },

      heroCarousel: [],

      originalActiveArtists: [],
      filteredArtists: [],
      viewableArtists: [],

      dropdown_regions: [],
      dropdown_icon: ['All', 'list', 'favorite', 'delete'],
      dropdown_edit: [{ text: 'All' }, { text: '100%' }, { text: '75%' }, { text: '50%' }, { text: '25%' }, { text: '0%' }]
    };
  },

  watch: {
    dd1: function dd1(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1;
        this.applyArtistFilters();
        this.filterArtistsByPage(this.filteredArtists);
      }
    },
    dd2: function dd2(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1;
        this.applyArtistFilters();
        this.filterArtistsByPage(this.filteredArtists);
      }
    },
    page: function page(newVal, oldVal) {
      if (newVal !== oldVal) {
        __WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default.a.scrollTo('#artist-grid-wrap', 500, this.scrollOptions);
        this.filterArtistsByPage(this.filteredArtists);
      }
    },
    originalActiveArtists: function originalActiveArtists(newVal, oldVal) {
      if (typeof newVal !== 'undefined' && newVal.length > 0 && newVal !== oldVal) {
        this.applyArtistFilters();
        this.filterArtistsByPage(newVal);
      }
    },
    artistSearch: function artistSearch(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === '') {
          this.filterArtistsByPage(this.filteredArtists);
          return;
        }
        console.log('artistSearch', newVal);
        var array = this.artistSearchHandler(newVal.toLowerCase(), this.originalActiveArtists, this.filteredArtists);
        if (typeof array !== 'undefined') {
          this.filterArtistsByPage(array);
          // console.log('artistSearch', newVal, array)
        }
      }
    }
  },
  computed: {},
  methods: {
    sortArtistsByName: function sortArtistsByName(a, b) {
      if (a.fullName < b.fullName) {
        return -1;
      }
      if (a.fullName > b.fullName) {
        return 1;
      }
      return 0;
    },
    filterArtistsByPage: function filterArtistsByPage(artists) {
      console.log('filterArtistsByPage');
      var mac = this.maxArtistCount;
      var al = artists.length;
      var start = (this.page - 1) * mac;
      this.numberOfPages = Math.ceil(al / mac);
      var rtn = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]._.clone(artists, true).splice(start, mac);
      // console.log('numberOfPages', al, mac, this.numberOfPages, rtn)
      this.viewableArtists = rtn;
    },
    applyArtistFilters: function applyArtistFilters() {
      var dd1Val = this.dd1 || 'All';
      var dd2Val = this.dd2 || 'All';
      // console.log('filtering artist by region', dd1Val)
      // console.log('filtering artist by category', dd2Val)
      this.filteredArtists = this.originalActiveArtists.filter(function (item) {
        // console.log(item.regionId, dd1Val)
        if (dd1Val === 'All') {
          return true;
        } else if (typeof item.city !== 'undefined' && item.city.toLowerCase().indexOf(dd1Val.toLowerCase()) >= 0) {
          return true;
        }
        return false;
      }).filter(function (item) {
        // console.log(item.fullName, item, dd2Val)
        if (dd2Val === 'All') {
          return true;
        } else if (typeof item.styles !== 'undefined') {
          // debugger
          if (typeof item.styles !== 'undefined' && Array.isArray(item.styles) && item.styles.indexOf(dd2Val) >= 0) {
            return true;
          }
        }
        return false;
      }).sort(this.sortArtistsByName);
    },
    artistSearchHandler: function artistSearchHandler(str, arr, arr2) {
      // var str = this.artistSearch
      // console.log('Searching for ', str, arr, arr2)
      if (typeof arr === 'undefined') {
        return;
      }
      return arr.filter(function (item) {
        // console.log(item.fullName.toLowerCase(), str, (item.fullName.toLowerCase().indexOf(str) >= 0))
        return item.fullName.toLowerCase().indexOf(str) >= 0;
      });
    },
    heroClickHandler: function heroClickHandler(item) {
      if (typeof item.url !== 'undefined') {
        console.log('heroClickHandler', item.url);
      }
    },
    fetchArtists: function fetchArtists() {
      var _this = this;

      // console.log('fetch artists')
      var url = this.$store.state.apiURL + '/artists';
      this.axios.get(url, this.$store.state.axiosConfig).then(function (response) {
        var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response.data);
        var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response.data).map(function (item, idx) {
          item['.key'] = keys[idx];
          return item;
        });
        // console.log('API | artists', data)

        var placeholderArtistImg = _this.$store.state.placeholderArtistImg;
        var artists = data.filter(function (artist) {
          return artist.status === 'active' && artist.enableDirectoryListing === true;
        }).map(function (item) {
          if (typeof item.bio !== 'undefined') {
            item.bio = unescape(item.bio);
          }
          if (typeof item.fullName !== 'undefined') {
            item.fullName = unescape(item.fullName);
          }
          if (typeof item.excerpt !== 'undefined') {
            item.excerpt = unescape(item.excerpt);
          }
          if (typeof item.profileCloudinaryURL === 'undefined' || item.profileCloudinaryURL === '') {
            item.profileCloudinaryURL = placeholderArtistImg;
          }
          return item;
        }).sort(_this.sortArtistsByName);

        var titleCase = _this.titleCase;
        _this.cities = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(artists.map(function (item) {
          return typeof item.city !== 'undefined' ? titleCase(item.city.toLowerCase()) : '';
        }))).sort();
        console.log('Artists cities', _this.cities);

        _this.cities.unshift('All');

        // console.log('setting artists', artists)
        // this.viewableArtists = Vue._.clone(artists, false)
        _this.originalActiveArtists = artists;
        // this.filterItemsByStatus(this.status)
      });
    },
    fetchEnterpriseDirectory: function fetchEnterpriseDirectory() {
      // console.log('fetch enterprise directory', this.$store.state, this.$store.state.apiURL)
      var id = window.VividArts.eId;
      if (typeof id === 'undefined' || id === '') {
        this.errorMsg = 'Invalid connection.';
        return;
      }
      var requestURL = this.$store.state.apiURL + '/enterprises/' + id + '/directory';
      // var payload = { }
      var vm = this;
      this.axios.get(requestURL, this.$store.state.axiosConfig).then(function (response) {
        var data = response.data;
        console.log('fetchEnterpriseDirectory', data);
        vm.directories = data;
        // console.log('API | enterprise directory', data, vm.directoryType)
        if (data === null) {
          return;
        }

        vm.directory = data[vm.directoryType] ? __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]._.clone(data[vm.directoryType], false) : {};
        console.log('directoryType ->');
        if (vm.directoryType === 'artists') {
          vm.activeCategories = vm.directory.categories;
          if (typeof vm.activeCategories !== 'undefined' && vm.activeCategories.length > 0) {
            vm.activeCategories.unshift({ name: 'All' });
          } else {
            vm.activeCategories = [{ name: 'All' }];
          }
        }
        if (typeof vm.directory.loop !== 'undefined') {
          vm.swiperOption.loop = vm.directory.loop;
        }
        if (typeof vm.directory.autoplay !== 'undefined') {
          vm.swiperOption.autoplay = vm.directory.autoplay;
        }
        if (typeof vm.directory.effect !== 'undefined') {
          vm.swiperOption.effect = vm.directory.effect;
        }
        if (typeof vm.directory.direction !== 'undefined') {
          vm.swiperOption.direction = vm.directory.direction;
        }
        if (typeof vm.directory.itemsPerPage !== 'undefined') {
          vm.maxArtistCount = vm.directory.itemsPerPage;
        }
        // console.log('active directory', vm.directory)
        // this.form = this.initFormWithData(this.artist)
      });
    },
    titleCase: function titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    }
  }
});

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 182,
	"./af.js": 182,
	"./ar": 189,
	"./ar-dz": 183,
	"./ar-dz.js": 183,
	"./ar-kw": 184,
	"./ar-kw.js": 184,
	"./ar-ly": 185,
	"./ar-ly.js": 185,
	"./ar-ma": 186,
	"./ar-ma.js": 186,
	"./ar-sa": 187,
	"./ar-sa.js": 187,
	"./ar-tn": 188,
	"./ar-tn.js": 188,
	"./ar.js": 189,
	"./az": 190,
	"./az.js": 190,
	"./be": 191,
	"./be.js": 191,
	"./bg": 192,
	"./bg.js": 192,
	"./bm": 193,
	"./bm.js": 193,
	"./bn": 194,
	"./bn.js": 194,
	"./bo": 195,
	"./bo.js": 195,
	"./br": 196,
	"./br.js": 196,
	"./bs": 197,
	"./bs.js": 197,
	"./ca": 198,
	"./ca.js": 198,
	"./cs": 199,
	"./cs.js": 199,
	"./cv": 200,
	"./cv.js": 200,
	"./cy": 201,
	"./cy.js": 201,
	"./da": 202,
	"./da.js": 202,
	"./de": 205,
	"./de-at": 203,
	"./de-at.js": 203,
	"./de-ch": 204,
	"./de-ch.js": 204,
	"./de.js": 205,
	"./dv": 206,
	"./dv.js": 206,
	"./el": 207,
	"./el.js": 207,
	"./en-au": 208,
	"./en-au.js": 208,
	"./en-ca": 209,
	"./en-ca.js": 209,
	"./en-gb": 210,
	"./en-gb.js": 210,
	"./en-ie": 211,
	"./en-ie.js": 211,
	"./en-nz": 212,
	"./en-nz.js": 212,
	"./eo": 213,
	"./eo.js": 213,
	"./es": 216,
	"./es-do": 214,
	"./es-do.js": 214,
	"./es-us": 215,
	"./es-us.js": 215,
	"./es.js": 216,
	"./et": 217,
	"./et.js": 217,
	"./eu": 218,
	"./eu.js": 218,
	"./fa": 219,
	"./fa.js": 219,
	"./fi": 220,
	"./fi.js": 220,
	"./fo": 221,
	"./fo.js": 221,
	"./fr": 224,
	"./fr-ca": 222,
	"./fr-ca.js": 222,
	"./fr-ch": 223,
	"./fr-ch.js": 223,
	"./fr.js": 224,
	"./fy": 225,
	"./fy.js": 225,
	"./gd": 226,
	"./gd.js": 226,
	"./gl": 227,
	"./gl.js": 227,
	"./gom-latn": 228,
	"./gom-latn.js": 228,
	"./gu": 229,
	"./gu.js": 229,
	"./he": 230,
	"./he.js": 230,
	"./hi": 231,
	"./hi.js": 231,
	"./hr": 232,
	"./hr.js": 232,
	"./hu": 233,
	"./hu.js": 233,
	"./hy-am": 234,
	"./hy-am.js": 234,
	"./id": 235,
	"./id.js": 235,
	"./is": 236,
	"./is.js": 236,
	"./it": 237,
	"./it.js": 237,
	"./ja": 238,
	"./ja.js": 238,
	"./jv": 239,
	"./jv.js": 239,
	"./ka": 240,
	"./ka.js": 240,
	"./kk": 241,
	"./kk.js": 241,
	"./km": 242,
	"./km.js": 242,
	"./kn": 243,
	"./kn.js": 243,
	"./ko": 244,
	"./ko.js": 244,
	"./ky": 245,
	"./ky.js": 245,
	"./lb": 246,
	"./lb.js": 246,
	"./lo": 247,
	"./lo.js": 247,
	"./lt": 248,
	"./lt.js": 248,
	"./lv": 249,
	"./lv.js": 249,
	"./me": 250,
	"./me.js": 250,
	"./mi": 251,
	"./mi.js": 251,
	"./mk": 252,
	"./mk.js": 252,
	"./ml": 253,
	"./ml.js": 253,
	"./mr": 254,
	"./mr.js": 254,
	"./ms": 256,
	"./ms-my": 255,
	"./ms-my.js": 255,
	"./ms.js": 256,
	"./mt": 257,
	"./mt.js": 257,
	"./my": 258,
	"./my.js": 258,
	"./nb": 259,
	"./nb.js": 259,
	"./ne": 260,
	"./ne.js": 260,
	"./nl": 262,
	"./nl-be": 261,
	"./nl-be.js": 261,
	"./nl.js": 262,
	"./nn": 263,
	"./nn.js": 263,
	"./pa-in": 264,
	"./pa-in.js": 264,
	"./pl": 265,
	"./pl.js": 265,
	"./pt": 267,
	"./pt-br": 266,
	"./pt-br.js": 266,
	"./pt.js": 267,
	"./ro": 268,
	"./ro.js": 268,
	"./ru": 269,
	"./ru.js": 269,
	"./sd": 270,
	"./sd.js": 270,
	"./se": 271,
	"./se.js": 271,
	"./si": 272,
	"./si.js": 272,
	"./sk": 273,
	"./sk.js": 273,
	"./sl": 274,
	"./sl.js": 274,
	"./sq": 275,
	"./sq.js": 275,
	"./sr": 277,
	"./sr-cyrl": 276,
	"./sr-cyrl.js": 276,
	"./sr.js": 277,
	"./ss": 278,
	"./ss.js": 278,
	"./sv": 279,
	"./sv.js": 279,
	"./sw": 280,
	"./sw.js": 280,
	"./ta": 281,
	"./ta.js": 281,
	"./te": 282,
	"./te.js": 282,
	"./tet": 283,
	"./tet.js": 283,
	"./th": 284,
	"./th.js": 284,
	"./tl-ph": 285,
	"./tl-ph.js": 285,
	"./tlh": 286,
	"./tlh.js": 286,
	"./tr": 287,
	"./tr.js": 287,
	"./tzl": 288,
	"./tzl.js": 288,
	"./tzm": 290,
	"./tzm-latn": 289,
	"./tzm-latn.js": 289,
	"./tzm.js": 290,
	"./uk": 291,
	"./uk.js": 291,
	"./ur": 292,
	"./ur.js": 292,
	"./uz": 294,
	"./uz-latn": 293,
	"./uz-latn.js": 293,
	"./uz.js": 294,
	"./vi": 295,
	"./vi.js": 295,
	"./x-pseudo": 296,
	"./x-pseudo.js": 296,
	"./yo": 297,
	"./yo.js": 297,
	"./zh-cn": 298,
	"./zh-cn.js": 298,
	"./zh-hk": 299,
	"./zh-hk.js": 299,
	"./zh-tw": 300,
	"./zh-tw.js": 300
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(616),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9eb38d9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
  __webpack_require__(594)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47617407",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
  __webpack_require__(599)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 613:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artist-profile",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "artist-page"
    }
  }, [(_vm.artist && (_vm.artist.backgroundURL || _vm.artist.profileCloudinaryURL)) ? _c('div', {
    staticClass: "background-header",
    style: ({
      backgroundImage: 'url(' + (_vm.artist.backgroundURL || _vm.artist.profileCloudinaryURL) + ')'
    })
  }) : _c('div', {
    staticClass: "background-header"
  }), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.artist.gallery,
      "index": _vm.galleryLightboxIndex
    },
    on: {
      "close": function($event) {
        _vm.galleryLightboxIndex = null
      }
    }
  }), _vm._v(" "), (_vm.artist) ? _c('v-container', {
    staticClass: "artist-profile-content",
    class: {
      'cv-tab': _vm.shouldIncludeCVTab
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "profile-overview pa-3",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {}, [_c('v-card-media', {
    attrs: {
      "src": _vm.artist.profileCloudinaryURL || _vm.placeHolderArtistImg,
      "height": "350px"
    }
  }), _vm._v(" "), (false) ? _c('v-btn', {
    staticClass: "follow-artist",
    nativeOn: {
      "click": function($event) {}
    }
  }, [_vm._v("\n                Follow Artist\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "pt-1 pb-1",
    attrs: {
      "primary-title": ""
    }
  }, [(_vm.urid != 3) ? _c('v-flex', {
    staticClass: "breadcrumbs-wrap hidden-md-and-up clearfix",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-breadcrumbs', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-icon', {
    attrs: {
      "slot": "divider"
    },
    slot: "divider"
  }, [_vm._v("chevron_right")]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "to": item.href
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("About " + _vm._s(_vm.artist.fullName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.artist.city))]), _vm._v(" "), (_vm.artist.tagline) ? _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.artist.tagline))]) : _vm._e()])], 1), _vm._v(" "), _c('v-slide-y-transition', [(_vm.artist.excerpt) ? _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.artist.excerpt))])]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "social-menu"
  }, [(_vm.artist.contactFacebook) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-facebook")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.facebookURL(_vm.artist.contactFacebook),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactFacebook))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.contactInstagram) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-instagram")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.instagramURL(_vm.artist.contactInstagram),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactInstagram))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.contactTwitter) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-twitter")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.twitterURL(_vm.artist.contactTwitter),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactTwitter))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.contactPinterest) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-pinterest")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pinterestURL(_vm.artist.contactPinterest),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactPinterest))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.contactWebsite) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-id-card-o")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.websiteURL(_vm.artist.contactWebsite),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactWebsite))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.contactEmail && _vm.artist.showEmail) ? _c('li', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": ""
    }
  }, [_c('span', [_c('v-icon', [_vm._v("fa-envelope-open")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.artist.contactEmail,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.contactEmail))])])], 1)], 1) : _vm._e()])], 1)], 1)]), _vm._v(" "), (_vm.activeTab) ? _c('v-flex', {
    staticClass: "profile-body pa-3",
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": "white darken-1",
      "dark": "",
      "tabs": ""
    }
  }, [_c('v-toolbar-title', [(_vm.urid != 3) ? _c('div', {
    staticClass: "breadcrumbs-wrap hidden-sm-and-down"
  }, [_c('v-breadcrumbs', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-icon', {
    style: ({
      color: _vm.themeColor
    }),
    attrs: {
      "slot": "divider"
    },
    slot: "divider"
  }, [_vm._v("chevron_right")]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(item) {
    return _c('v-breadcrumbs-item', {
      key: item.text,
      attrs: {
        "disabled": item.disabled,
        "to": item.href
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.enableEditArtistLink && this.$route.params.id) ? _c('router-link', {
    staticClass: "btn btn--raised pa-2",
    attrs: {
      "tag": "button",
      "to": {
        name: 'EditArtist',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("\n          Edit Profile")]) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "color": "grey darken-1"
    },
    slot: "extension",
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name,
      attrs: {
        "href": ("#tab-" + (tab.name))
      }
    }, [_c('v-icon', [_vm._v(_vm._s(tab.icon))]), _vm._v(" "), _c('span', {
      staticClass: "tab-title"
    }, [_vm._v(" " + _vm._s(tab.name))])], 1)
  }))], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab, key) {
    return _c('v-tab-item', {
      key: tab.name,
      attrs: {
        "id": ("tab-" + (tab.name))
      }
    }, [(tab.name === 'artworks') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.artworkMarkers && _vm.artworkMarkers.length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('gmap-map', {
      ref: "artworksMap",
      refInFor: true,
      staticStyle: {
        "width": "100%",
        "height": "300px"
      },
      attrs: {
        "center": _vm.mapCenter,
        "zoom": 15,
        "map-type-id": "terrain"
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "options": _vm.infoOptions,
        "position": _vm.infoWindowPos,
        "opened": _vm.infoWinOpen
      },
      on: {
        "closeclick": function($event) {
          _vm.infoWinOpen = false
        }
      }
    }, [_c('div', {
      staticClass: "artwork-info-window"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("thumbnailURL")(_vm.infoImage),
        "width": "90",
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.infoContent))])])]), _vm._v(" "), _c('gmap-cluster', _vm._l((_vm.artworkMarkers), function(m, i) {
      return _c('gmap-marker', {
        key: i,
        attrs: {
          "position": m.position,
          "icon": m.icon,
          "clickable": true
        },
        on: {
          "click": function($event) {
            _vm.toggleInfoWindow(m, i)
          }
        }
      })
    }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-container', _vm._b({
      attrs: {
        "fluid": ""
      }
    }, 'v-container', ( _obj = {}, _obj["grid-list-lg"] = true, _obj ), false), [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.artistArtworks), function(artwork, imageIndex) {
      return _c('v-flex', {
        key: artwork['.key'],
        attrs: {
          "xs4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('a', {
        on: {
          "click": function($event) {
            _vm.lightboxIndex = imageIndex
          }
        }
      }, [(artwork.cloudinaryImageURL) ? _c('v-card-media', {
        attrs: {
          "src": _vm._f("thumbnailURL")(artwork.cloudinaryImageURL),
          "height": "150px"
        }
      }) : _vm._e()], 1)])], 1)
    }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'about') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pa-3",
      attrs: {
        "row": "",
        "wrap": "",
        "class": "pa-3"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(_vm.artist.bio) ? _c('div', {
      staticClass: "about text-content",
      domProps: {
        "innerHTML": _vm._s(_vm.artist.bio)
      }
    }) : _c('div', {
      staticClass: "about text-content empty"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')])])], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'gallery') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pa-3",
      attrs: {
        "row": "",
        "wrap": "",
        "class": "pa-3"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-container', _vm._b({
      attrs: {
        "fluid": ""
      }
    }, 'v-container', ( _obj$1 = {}, _obj$1["grid-list-lg"] = true, _obj$1 ), false), [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.artist.gallery), function(image, idx) {
      return _c('v-flex', {
        key: idx,
        attrs: {
          "xs12": "",
          "md4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.galleryLightboxIndex = idx
          }
        }
      }, [(image) ? _c('v-card-media', {
        attrs: {
          "src": _vm._f("thumbnailURL")(image),
          "height": "150px"
        }
      }) : _vm._e()], 1)])], 1)
    }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (tab.name === 'cv') ? _c('v-card', {
      staticClass: "pa-3",
      attrs: {
        "flex": "",
        "flat": ""
      }
    }, [(_vm.artist.exhibitions && _vm.artist.exhibitions.length) ? _c('div', [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Exhibitions")]), _vm._v(" "), _c('p', [_vm._v("Galleries, museums, or festivals exhibits with their work.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_vm._l((_vm.artist.exhibitions), function(item, idx) {
      return [_c('v-list-tile', {
        key: item.title
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [(item.url) ? _c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v("\n                              " + _vm._s(item.name) + "\n                            ")]) : _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("moment")(item.startDate, "ddd MMM D, YYYY")))]), _vm._v(" "), (item.endDate) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("moment")(item.endDate, "ddd MMM D, YYYY")))]) : _vm._e()])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.podcasts && _vm.artist.podcasts.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Podcast")]), _vm._v(" "), _c('p', [_vm._v("Podcasts in which they where featured in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.artist.podcasts && _vm.artist.podcasts.length) ? _c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.podcasts), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.show))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(item.episodeDate))])], 1)], 1)]
    })], 2) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.videos && _vm.artist.videos.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Videos")]), _vm._v(" "), _c('p', [_vm._v("Videos in which they where featured in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.videos), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(item.episodeDate))])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.artist.printBlogs && _vm.artist.printBlogs.length) ? _c('div', [_c('v-flex', {
      staticClass: "mt-5",
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "pt-5 headline"
    }, [_vm._v("Print/Blog Mentions")]), _vm._v(" "), _c('p', [_vm._v("Magazines or blogs in which they where mentioned in.")])]), _vm._v(" "), _c('v-layout', {
      staticClass: "portfolio-exhibitions cv-content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-list', {
      attrs: {
        "two-line": ""
      }
    }, [_vm._l((_vm.artist.printBlogs), function(item, idx) {
      return [_c('v-list-tile', {
        key: idx
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
        attrs: {
          "href": item.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.url))])]), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "pb-2"
      }, [_vm._v(_vm._s(item.date))])], 1)], 1)]
    })], 2)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (tab.name === 'store') ? _c('v-card', {
      staticClass: "content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }) : _vm._e()], 1)
    var _obj;
    var _obj$1;
  }))], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    class: _vm.$route.name,
    attrs: {
      "light": ""
    }
  }, [_c('main', [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "main-panel vap-fullscreen"
  }, [_c('fullscreen-content')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "vivid-arts-directory"
  }, [(!_vm.directory) ? _c('pulse-loader', {
    staticClass: "va-page-loader",
    attrs: {
      "color": _vm.color,
      "size": _vm.size,
      "margin": _vm.margin,
      "radius": _vm.radius
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.enterpriseLogo) ? _c('v-flex', {
    staticClass: "page-header mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card-media', {
    staticClass: "enterprise-logo",
    attrs: {
      "src": _vm.enterpriseLogo,
      "contain": _vm.enterpriseLogoContain,
      "height": "100px"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.directory && _vm.directory.enableHero && _vm.directory.gallery && _vm.directory.gallery.length) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.directory.gallery), function(item, i) {
    return _c('swiper-slide', {
      key: i,
      attrs: {
        "src": item.src
      }
    }, [(item.url) ? _c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "slider-img",
      style: ({
        backgroundImage: 'url(' + item.src + ')'
      })
    }), _vm._v(" "), (item.caption) ? _c('div', {
      staticClass: "slider-caption-wrap"
    }, [_c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                " + _vm._s(item.caption) + "\n              ")])]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "slider-img",
      style: ({
        backgroundImage: 'url(' + item.src + ')'
      })
    }), _vm._v(" "), (item.caption) ? _c('div', {
      staticClass: "slider-caption-wrap"
    }, [_c('div', {
      staticClass: "caption-text"
    }, [_vm._v("\n                " + _vm._s(item.caption) + "\n              ")])]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "artist-search mt-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('p', {
    staticClass: "headline"
  }, [_vm._v("Filters")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "search-textfield-wrap",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search-textfield",
    attrs: {
      "name": "input-1-3",
      "label": "Search Artist",
      "single-line": "",
      "prepend-icon": "search"
    },
    model: {
      value: (_vm.artistSearch),
      callback: function($$v) {
        _vm.artistSearch = $$v
      },
      expression: "artistSearch"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.artistSearch),
      expression: "artistSearch"
    }],
    staticClass: "clear-search btn",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.artistSearch = ''
      }
    }
  }, [_c('v-icon', [_vm._v("fa-times-circle")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.viewableArtists.length) + "/" + _vm._s(_vm.fRegions.length))]), _vm._v(" "), _c('p', [_vm._v("Region")]), _vm._v(" "), _c('v-select', {
    staticClass: "capitalize",
    attrs: {
      "items": _vm.cities,
      "overflow": "",
      "label": "Select"
    },
    model: {
      value: (_vm.dd1),
      callback: function($$v) {
        _vm.dd1 = $$v
      },
      expression: "dd1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('p', [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.activeCategories,
      "overflow": "",
      "item-value": "name",
      "item-text": "name",
      "label": "Select"
    },
    model: {
      value: (_vm.dd2),
      callback: function($$v) {
        _vm.dd2 = $$v
      },
      expression: "dd2"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    ref: "artistGridWrap",
    attrs: {
      "xs12": "",
      "id": "artist-grid-wrap"
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": ""
    }
  }, 'v-container', ( _obj = {}, _obj["grid-list-md"] = true, _obj ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.viewableArtists), function(artist) {
    return (_vm.viewableArtists.length > 0) ? _c('v-flex', {
      key: artist['.key'],
      staticClass: "pa-4",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": "",
        "tile": ""
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist['.key']
          }
        }
      }
    }, [_c('v-card-media', {
      staticClass: "profile-image",
      attrs: {
        "src": _vm._f("thumbnailURL")(artist.profileCloudinaryURL),
        "height": "200px"
      }
    })], 1), _vm._v(" "), _c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('router-link', {
      staticClass: "artist-name",
      attrs: {
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist['.key']
          }
        }
      }
    }, [_c('h3', {
      staticClass: "headline mb-0"
    }, [_vm._v(_vm._s(artist.fullName))])]), _vm._v(" "), _c('div', {
      staticClass: "artist-expcert"
    }, [_vm._v(_vm._s(_vm._f("truncate")(artist.excerpt, 150)))])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('router-link', {
      staticClass: "indigo--text btn btn--flat",
      attrs: {
        "tag": "button",
        "to": {
          name: 'ArtistProfile',
          params: {
            id: artist['.key']
          }
        }
      }
    }, [_vm._v("View Profile")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.viewableArtists.length === 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "headline text-xs-center"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), (_vm.viewableArtists.length) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.numberOfPages,
      "circle": ""
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)
  var _obj;
},staticRenderFns: []}

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[333]);


// WEBPACK FOOTER //
// static/js/app.20da59faa61c0c59a4ea.js